<template>
  <div class="recap" :class="save_to + '_recap'">
    <div class="recap_label" v-html="label"></div>
    <div v-if="save_to == 'address' && value" class="recap_value recap_value_address">
      <span class="recap_value_address-address">{{ value.address }}</span>
      <span class="recap_value_address-comma" v-if="value.complement">, </span>
      <span class="recap_value_address-complement" v-if="value.complement">{{ value.complement }}</span>
      <span class="recap_value_address-comma" v-if="value.postcode">, </span>
      <span class="recap_value_address-postcode">{{ value.postcode }}&nbsp;</span>
      <span class="recap_value_address-city">{{ value.city }}</span>
    </div>
    <div v-else class="recap_value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "Recap",
  data: function() {
    return {};
  },
  props: {
    save_to: String,
    label: String,
    value: [String, Object, Number],
  },
  computed: {},
};
</script>
